import { ChevronDown } from 'lucide-react'
import { useState } from 'react'
import type { FacetsOut } from '../lib/api'

const groups: { key: keyof FacetsOut; label: string }[] = [
  { key: 'location', label: 'Location' },
  { key: 'current_role', label: 'Current role' },
  { key: 'industry', label: 'Industry' },
  { key: 'company_stage', label: 'Stage' },
  { key: 'skills', label: 'Skills' },
  { key: 'career_signals', label: 'Career signals' },
  { key: 'exclude', label: 'Excluding' },
]

export function FacetsPanel({ facets, defaultOpen = false }: { facets: FacetsOut; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen)
  const allEmpty = groups.every((g) => (facets[g.key] as string[]).length === 0)
  if (allEmpty && facets.expanded_queries.length === 0) return null

  return (
    <div className="card">
      <button
        className="w-full flex items-center justify-between px-5 py-3 text-sm font-medium text-gray-200"
        onClick={() => setOpen(!open)}
      >
        <span>How the query was understood</span>
        <ChevronDown
          size={16}
          className={`transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="px-5 pb-5 space-y-4 border-t border-border/50 pt-4">
          <div className="grid grid-cols-2 gap-4">
            {groups.map((g) => {
              const vals = facets[g.key] as string[]
              if (!vals?.length) return null
              return (
                <div key={g.key}>
                  <div className="label mb-1.5">{g.label}</div>
                  <div className="flex flex-wrap gap-1.5">
                    {vals.map((v) => (
                      <span key={v} className="pill">
                        {v}
                      </span>
                    ))}
                  </div>
                </div>
              )
            })}
          </div>

          {facets.expanded_queries.length > 0 && (
            <div>
              <div className="label mb-1.5">Searched as multiple angles</div>
              <ul className="space-y-1 text-sm text-gray-400">
                {facets.expanded_queries.map((q, i) => (
                  <li key={i}>· {q}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
